<div class="restoration-actions">
  <button
    *roleVisibility="['create', 'update']; classNames: classNames"
    type="button"
    mat-raised-button
    (click)="addRestorationHandler()">
    {{ 'Aggiungi restauro' | translate }}
  </button>
</div>
<div [formGroup]="form">
  <ui-draggable-list
    *ngIf="restorations.length > 0; else noItems"
    [items]="restorations"
    (dropComplete)="orderRestorationHandler($event)">
    <ng-template
      uiListItem
      let-restoration="item"
      let-i="index">
      <div class="restoration-container">
        <div
          *roleVisibility="['create', 'update']; classNames: classNames"
          class="restoration-actions">
          <button
            mat-icon-button
            type="button"
            (click)="removeRestorationHandler(i)">
            <mat-icon>delete</mat-icon>
          </button>
          <button
            mat-icon-button
            type="button"
            (click)="editRestorationHandler(restoration, i)">
            <mat-icon>edit</mat-icon>
          </button>
        </div>
        <div
          class="restoration-info-container"
          [formArrayName]="i">
          <div>
            <small class="restoration-info">
              {{ 'Descrizione' | translate }}: {{ restoration?.descrizione  }}
            </small>
            <small class="restoration-info">
              {{ 'Esecutore' | translate }}: {{ restoration?.esecutore }}
            </small>
            <small class="restoration-info">
              {{ 'Data Inizio' | translate }}: {{ restoration?.dataInizio }}
            </small>
            <small class="restoration-info">
              {{ 'Data Fine' | translate }}: {{ restoration?.dataFine }}
            </small>
            <small class="restoration-info">
              {{ 'Allegati presenti' | translate }}: {{ restoration?.allegati?.length }}
            </small>
          </div>
        </div>
      </div>
    </ng-template>
  </ui-draggable-list>

  <ng-template #noItems>
    <ui-no-items [size]="40"></ui-no-items>
  </ng-template>
</div>
